/*
 *
 * Tickets constants
 *
 */

export const DEFAULT_ACTION = 'app/Tickets/DEFAULT_ACTION';
